import { render, staticRenderFns } from "./GetStarted.vue?vue&type=template&id=38b0b58e&"
import script from "./GetStarted.js?vue&type=script&lang=js&"
export * from "./GetStarted.js?vue&type=script&lang=js&"
import style0 from "./GetStarted.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports